import React from 'react';

const ReuploadControl = ({ onReupload }) => (
    <div style={{
        position: 'absolute',
        bottom: '16px',
        right: '16px',
        background: 'white',
        padding: '12px',
        borderRadius: '12px',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    }}>
        <button
            onClick={onReupload}
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '8px 16px',
                background: 'white',
                color: '#4a86e8',
                border: '1px solid #4a86e8',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.2s ease',
                ':hover': {
                    background: 'rgba(74, 134, 232, 0.05)',
                    transform: 'translateY(-1px)'
                }
            }}
        >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4a86e8" strokeWidth="2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="17 8 12 3 7 8" />
                <line x1="12" y1="3" x2="12" y2="15" />
            </svg>
            Reupload Map
        </button>
    </div>
);

export default ReuploadControl; 